<template>
    <div
        v-if="brandName === 'StoreKit'"
        class="mx-auto mb-3 flex items-center justify-center py-16 sm:py-8"
        role="presentation"
    >
        <p v-if="$route.params.venueSlug === 'bbk'" class="block mr-2"
            >❤️ Sammy</p
        >
        <span class="text-sm text-primary">served with</span>
        <a
            :href="`${brandLink}?utm_source=internal&utm_medium=referral&utm_campaign=powered_by_${$route.params.venueSlug}`"
            aria-label="Powered by storekit - sign up here"
            rel="noreferrer noopener"
            target="_blank"
        >
            <store-kit class="ml-2 h-6" />
        </a>
        {{ venueId }}
    </div>

    <span v-else role="presentation">
        {{ $t('poweredBy.poweredBy') }}
        <a
            :aria-label="`Powered by ${brandName} - sign up here`"
            :href="`${brandLink}?utm_source=internal&utm_medium=referral&utm_campaign=powered_by_${$route.params.venueSlug}`"
            rel="noreferrer noopener"
            target="_blank"
        >
            {{ brandName }}
        </a>
    </span>
</template>

<script>
import StoreKit from '@/components/icons/StoreKit';

export default {
    name: 'PoweredBy',
    props: {
        venueId: {
            type: String,
            required: false,
            default: null
        }
    },
    components: { StoreKit },
    data() {
        return {
            brandName: import.meta.env.VITE_BRANDING_NAME,
            brandLink: import.meta.env.VITE_BRANDING_LINK
        };
    }
};
</script>
